export default __webpack_public_path__ + "static/media/bannerSmall5.9de5b3f6.png";